import { render } from "./QuestionModeration.vue?vue&type=template&id=e3a93d98"
import script from "./QuestionModeration.vue?vue&type=script&lang=js"
export * from "./QuestionModeration.vue?vue&type=script&lang=js"

import "./QuestionModeration.vue?vue&type=style&index=0&id=e3a93d98&lang=scss"

import exportComponent from "/builds/mindthegapstudio/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__